import { DraftReturnShipment } from "./draft-return";

/**
 * Checks if all draft return shipments are eligible for ReturnBear drop-off.
 * A shipment is eligible if it has ReturnBear details with locations.
 */
export function areAllDraftReturnShipmentsReturnBearEligible(
  shipments: DraftReturnShipment[],
): boolean {
  if (shipments.length === 0) {
    return false;
  }

  return shipments.every(
    (shipment) => !!shipment.returnBearDetails?.locations?.length,
  );
}
